import { Box, BoxProps, useTheme } from '@rossum/ui/material';

const circles = [1.5, 2.25, 3.25, 4.25, 5.25];

export type RadarProps = {
  /**
   * Base radius used to compute ring sizes.
   * Rings are calculated as baseRadius * circle^1.2
   */
  baseRadius: number;
  children?: React.ReactNode;
} & BoxProps;

export const Radar = ({ baseRadius, children, sx, ...rest }: RadarProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'visible',
        ...sx,
      }}
      {...rest}
    >
      <Box
        component="svg"
        viewBox="0 0 2000 2000"
        sx={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          width: 2000,
          height: 2000,
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none',
        }}
      >
        {circles.map(circle => {
          const r = (baseRadius * circle ** 1.2) / 2;
          const opacity = 0.8 / 1.2 ** circle;

          return (
            <circle
              key={circle}
              cx={1000}
              cy={1000}
              r={r}
              fill="none"
              stroke={theme.palette.action.selected}
              strokeWidth={1}
              opacity={opacity}
            />
          );
        })}
      </Box>
      {children}
    </Box>
  );
};
